import React from "react";
import { usePermissions } from "./PermissionProvider";

export default function Can({ permission, children }) {
  const { permissions } = usePermissions();
  return permissions.includes(permission) ? <>{children}</> : null;
}
